import { Component, forwardRef, Input } from '@angular/core';

@Component({
  selector: 'hub-filter-chip',
  templateUrl: './hub-filter-chip.component.html',
  styleUrls: ['./hub-filter-chip.component.scss'],
  providers: [],
})
export class HubFilterChipComponent {
  @Input() label: string = 'Select Date';
  @Input() miniLabel: string = '10';
  @Input() color?: string = '#EE3158';
  @Input() altColor?: string = '#F4F3F3';
  @Input() selected?: boolean = false;

  @Input() icon1: string = 'mobile';
  @Input() icon2: string = 'send-alt-2';
  @Input() iconColor?: string = '#6D6D6D';
}
